import React, { createContext, useContext, useState } from 'react';
import { getSectionColor } from '../utils/colors';

const SectionColorContext = createContext();

export const useSectionColor = () => {
  const context = useContext(SectionColorContext);
  if (!context) {
    throw new Error('useSectionColor must be used within a SectionColorProvider');
  }
  return context;
};

export const SectionColorProvider = ({ children }) => {
  const [activeSection, setActiveSection] = useState('about');
  const currentColors = getSectionColor(activeSection);

  return (
    <SectionColorContext.Provider value={{
      activeSection,
      setActiveSection,
      currentColors,
      currentColor: currentColors.text
    }}>
      {children}
    </SectionColorContext.Provider>
  );
}; 